
// 2021 - @framerate
// I'm adding some new constants here to separate them from above, ideally
// I'd like to change this to use a more formal actions/constants/reducers format
// in the future since nobody really uses actionCreators any more
export const SET_COURSES_TO_ADD = '@@COURSEMATCH/SET_COURSES_TO_ADD'


// WEBPACK FOOTER //
// ./src/constants/general.js